import { render, staticRenderFns } from "./ClaimDetails.vue?vue&type=template&id=ddd078cc&"
import script from "./ClaimDetails.vue?vue&type=script&lang=js&"
export * from "./ClaimDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports